import { useAuthContext } from './use-auth';

export const useCurrentUser = () => {
  const context = useAuthContext();

  if (!context) {
    throw new Error('useCurrentUser must be used within an AuthContextProvider');
  }

  return context.user;
};

export type CurrentUser = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
};
